export const TASK_STATUS_COLORS = {
	'not-started': '#FCA5A5',
	'in-progress': '#FDBA74',
	completed: '#6EE7B7',
	declined: '#6EE7B7',
	rejected: '#FCA5A5',
	closed: '#E2E8F0',
} as const

export const CYCLE_STEP_COLORS = {
	cycle_start: '#93C5FD',
	edit_rater_list: '#CBD5E1',
	approve_rater_list: '#FCA5A5',
	self_evaluation: '#6EE7B7',
	group_evaluation: '#FDBA74',
	manager_evaluation: '#DBEAFE',
	unsolicited_evaluation: '#F1F5F9',
	review: '#FECACA',
	release: '#FFEDD5',
	acknowledge: '#FEF2F2',
	email: '#EFF6FF',
	hold: '#F8FAFC',
	cycle_end: '#93C5FD',
} as const

export const TASK_STATUS_LABELS = {
	'not-started': 'Not Started',
	'in-progress': 'In Progress',
	completed: 'Completed',
	declined: 'Declined',
	rejected: 'Rejected',
	closed: 'Closed',
} as const

export const CYCLE_STEP_LABELS = {
	cycle_start: 'Cycle Start',
	edit_rater_list: 'Edit Rater List',
	approve_rater_list: 'Approve Rater List',
	self_evaluation: 'Self Evaluation',
	group_evaluation: 'Group Evaluation',
	manager_evaluation: 'Manager Evaluation',
	unsolicited_evaluation: 'Unsolicited Evaluation',
	review: 'Review',
	release: 'Release',
	acknowledge: 'Acknowledge',
	email: 'Email',
	hold: 'Hold',
	cycle_end: 'Cycle End',
} as const
